export default function convertToXDot01(number) {
  if (number < 0) {
    throw new Error("The number must be a positive integer or float.");
  }
  const integerPart = Math.floor(number);
  return parseFloat(integerPart + ".01");
}
